export var AutomationNodeTypes;
(function (AutomationNodeTypes) {
    AutomationNodeTypes["INIT"] = "INIT";
    AutomationNodeTypes["QUEUE"] = "QUEUE";
    AutomationNodeTypes["CONDITION"] = "CONDITION";
    AutomationNodeTypes["TAG"] = "TAG";
    AutomationNodeTypes["REPLY"] = "REPLY";
    AutomationNodeTypes["WAIT"] = "WAIT";
    AutomationNodeTypes["STOP"] = "STOP";
    AutomationNodeTypes["CLOSE"] = "CLOSE";
})(AutomationNodeTypes || (AutomationNodeTypes = {}));
export var AutomationChannel;
(function (AutomationChannel) {
    // TEXT
    AutomationChannel["WIDGETCHAT"] = "widgetchat";
    AutomationChannel["CONTACTFORM"] = "contact_form";
    AutomationChannel["EMAIL"] = "email";
    AutomationChannel["FACEBOOKMESSENGER"] = "facebookmessenger";
    AutomationChannel["WHATSAPP"] = "whatsapp";
    // VOICE
    AutomationChannel["PSTNPHONE"] = "pstnphone";
    AutomationChannel["VOICEMAIL"] = "voicemail";
    AutomationChannel["CALLBACK"] = "callback";
})(AutomationChannel || (AutomationChannel = {}));
export var AutomationChannelHumanNames;
(function (AutomationChannelHumanNames) {
    // TEXT
    AutomationChannelHumanNames["widgetchat"] = "Chat";
    AutomationChannelHumanNames["contact_form"] = "Contact form";
    AutomationChannelHumanNames["email"] = "Email";
    AutomationChannelHumanNames["facebookmessenger"] = "Facebook Messenger";
    AutomationChannelHumanNames["whatsapp"] = "WhatsApp";
    // VOICE
    AutomationChannelHumanNames["pstnphone"] = "Phone";
    AutomationChannelHumanNames["voicemail"] = "Voicemail";
    AutomationChannelHumanNames["callback"] = "Callback";
})(AutomationChannelHumanNames || (AutomationChannelHumanNames = {}));
export var AutomationTrigger;
(function (AutomationTrigger) {
    AutomationTrigger["NONE"] = "NONE";
    AutomationTrigger["CONVERSATION_ASSIGNED"] = "CONVERSATION_ASSIGNED";
    AutomationTrigger["CONVERSATION_ABANDONED"] = "CONVERSATION_ABANDONED";
    AutomationTrigger["CONVERSATION_CLOSED"] = "CONVERSATION_CLOSED";
    AutomationTrigger["CONVERSATION_ADDED_TO_QUEUE"] = "CONVERSATION_ADDED_TO_QUEUE";
    AutomationTrigger["MESSAGE_SEND_BY_AGENT"] = "MESSAGE_SEND_BY_AGENT";
    AutomationTrigger["MESSAGE_SEND_BY_USER"] = "MESSAGE_SEND_BY_USER";
})(AutomationTrigger || (AutomationTrigger = {}));
export const AutomationTriggerHumanNames = {
    NONE: 'None',
    CONVERSATION_ASSIGNED: 'Conversation assigned to agent',
    CONVERSATION_ABANDONED: 'Conversation abandoned',
    CONVERSATION_CLOSED: 'Conversation closed',
    CONVERSATION_ADDED_TO_QUEUE: 'Conversation added to queue',
    MESSAGE_SEND_BY_AGENT: 'Message sent by agent',
    MESSAGE_SEND_BY_USER: 'Message sent by customer',
};
